export default __webpack_public_path__ + "static/media/38.89adf09b.jpg";